module.exports = __webpack_public_path__ + "img/xmark2.180acc4f.svg";